import { Button } from '@/components/atoms'
import { useTranslation } from 'react-i18next'

export type DailyEmailExportLimitModalContentProps = {
    onClose: () => void
}

export const DailyEmailExportLimitModalContent: React.FC<
    DailyEmailExportLimitModalContentProps
> = ({ onClose }) => {
    const { t } = useTranslation('translations')

    return (
        <div className="flex flex-row-reverse border-t border-t-neutral-200 px-6 py-4">
            <Button
                name="close"
                variant="solidPrimary"
                size="large"
                onClick={onClose}
                className="whitespace-nowrap"
                data-testid="daily-limit-modal-close-button"
            >
                {t('common.exportByEmail.daily_limit_reached.closeButton')}
            </Button>
        </div>
    )
}
